import React, { ReactNode } from 'react';

interface NodeFrameWrapperProps {
  children: ReactNode;
  borderRadius?: number;
  className?: string;
}

export const NodeFrameWrapper: React.FC<NodeFrameWrapperProps> = ({
  children,
  borderRadius = 8,
  className = '',
}) => {
  return (
    <div
      className={`w-full h-full overflow-hidden ${className}`}
      style={{
        borderRadius: `${borderRadius}px`,
        isolation: 'isolate'
      }}
    >
      {children}
    </div>
  );
};
